/**
 * Rainbow Interests — deployment content bundle.
 *
 * This is NOT the CompanionProfile. Companion identity (name, wordmark,
 * icon, avatar) lives in `companion/profiles/toto.js`. This file holds the
 * *narrative* Rainbow tells inside the product — long-form persona scripts,
 * login marketing, Home dashboard copy — the deployment-specific voice.
 *
 * Deployments are pluggable: a school deployment ships `school.js`, a
 * healthcare deployment ships `healthcare.js`, each with its own narrative
 * bundle. The companion is a separate axis of customization from the
 * deployment story.
 *
 * Rule of thumb for what belongs here:
 *   - Persona names, boutique cities, worked-example sentences ✅
 *   - Marketing copy that references the operating philosophy ✅
 *   - Long-form intro screens & tour scripts ✅
 *   - Anything that would be *rewritten* for a different market ✅
 *
 * What does NOT belong here (belongs on CompanionProfile):
 *   - The companion's own name / wordmark
 *   - Icon glyphs, avatar keys, chat CTAs
 *   - Terminology mappings (guest/boutique/teammate)
 */
const rainbowDeployment = {
  id: "rainbow",
  organizationLegalName: "Rainbow Interests LLC",
  organizationShortName: "Rainbow",

  // Login screen — everything the sign-in surface renders.
  login: {
    productSummary:
      "helps owners, district leaders, managers and therapists across our boutiques share the operating rhythm every day.",
    signInHeadingSuffix: "Sign in to",
  },

  // Guided tour personas — Rainbow-specific narrative. Each item is a
  // caption / voice line the tour renders in sequence.
  tour: {
    personas: [
      {
        name: "Katrina Gell",
        role: "Chief Operating Officer",
        caption:
          "Katrina opens her operating home on her phone. Every boutique's morning is one glance away.",
        voice:
          "Housekeeping at PLT just crossed 92% of monthly cap. A nudge already went to Damon. The fix might happen before I finish this email.",
      },
      {
        name: "Damon Mitchell",
        role: "General Manager · Plantation",
        caption:
          "The gratuity Damon logged 60 minutes ago is now a green claim card on Anastacia's Home. The system connected them without either of them noticing.",
        voice:
          "One nudge, one confirmation. My team knows the money is theirs before the day is over.",
      },
    ],
  },

  // Home dashboard signal labels — the small phrases that describe what
  // the platform is doing in the background.
  home: {
    attentionEngineLabel: "attention engine",
    housekeepingCapExample:
      "Housekeeping at 92% of cap. A nudge went out 2 minutes ago. No email needed.",
  },
};

export default rainbowDeployment;
